<template>
    <div
        class="card-event relative mt-14px flex flex-col md:flex-row"
        v-click-outside="hideDetails"
    >
        <a
            v-if="isCampusCyberEvent(event) && event.acf.registration_link"
            :href="event.acf.registration_link"
            target="_blank"
        >
            <button
                class="focus:outline-none absolute top-0 right-0 inline-flex uppercase font-medium items-center leading-none text-red-800 bg-red-100 h-33px px-10px duration-300 transition-all hover:bg-red-800 hover:text-white z-10"
            >
                {{ inscriptionLabel }}
            </button>
        </a>
        <div class="card-header h-140px flex">
            <div
                class="card-date w-1/2 flex flex-col items-center justify-center"
                :class="{
                    'bg-blue-800 text-white bg-contain' : isCampusCyberEvent(event),
                    'bg-gray-100 text-blue-800' : !isCampusCyberEvent(event)
                }"
                :style="getStyle(event)"
            >
                <p class="day text-5xl leading-none font-bold text-center">{{ getDayEvent(event) }}</p>
                <p class="month text-center leading-none font-medium uppercase">{{ getMonthEvent(event) }}</p>
                <p class="year text-center font-medium uppercase">{{ getYearEvent(event) }}</p>
            </div>
            <div
            class="w-1/2 flex-none bg-cover bg-center"
            :style="`background-image: url(${getEventThumbnail(event)});`"
            >
            </div>
        </div>
        <div class="card-content relative flex-1 p-20px border border-gray-100">
            <h2 class="text-2xl leading-none font-bold uppercase">{{ event.title.rendered }}</h2>
            <div class="mt-1">
                <p>{{ event.acf.location }}</p>
                <time :datetime="event.acf.start_date">{{ getDatesEventInfos(event) }}</time>
            </div>
            <span
                class="mt-1 text-base text-red-800 uppercase font-medium cursor-pointer inline-block"
                @click="toogleDetails"
            >
                <span v-if="showDetails">{{ hideLabel }}</span>
                <span v-else>{{ detailsLabel }}</span>
            </span>
            <div v-show="showDetails" class="single-wysiwyg" v-html="event.acf.details"></div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import ClickOutside from 'vue-click-outside'

export default {
    directives: {
        ClickOutside
    },
    props: {
        event: {
            type: Object,
            default: {}
        },
        inscriptionLabel: {
            type: String,
            default: 'S\'inscrire'
        },
        detailsLabel: {
            type: String,
            default: 'Détails'
        },
        hideLabel: {
            type: String,
            default: 'Masquer'
        },
        eventBackground: {
            type: String,
            default: '/wp-content/themes/orange-campus/src/img/event-background.jpg'
        }
    },
    data() {
        return {
            showDetails: false
        }
    },
    methods: {
        getEventThumbnail(event) {
            return event.acf.image ? event.acf.image.sizes['large'] : ''
        },
        getMore() {
            this.page++;
            this.getEvents()
        },
        isCampusCyberEvent(event) {
            return event._embedded['wp:term'][0][0]['slug'] === 'campus-cyber' ? true : false
        },
        getDayEvent(event) {
            return moment(event.acf.start_date).format('D')
        },
        getMonthEvent(event) {
            return moment(event.acf.start_date).format('MMMM')
        },
        getYearEvent(event) {
            return moment(event.acf.start_date).format('YYYY')
        },
        getDatesEventInfos(event) {
            return moment(event.acf.start_date).format('D') + ' ' + moment(event.acf.start_date).format('MMM')
        },
        toogleDetails() {
            this.showDetails = !this.showDetails
        },
        hideDetails() {
            this.showDetails = false
        },
        getStyle(event) {
            return this.isCampusCyberEvent(event) ? `background-image: url(` + this.eventBackground + `);` : ''
        }
    }
};
</script>

<style scoped>
.day { margin-bottom: 10px; }
</style>
